// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const ponyta: PokeData = {
  "id": 77,
  "name": "ponyta",
  "height": 10,
  "weight": 300,
  "base_experience": 82,
  "types": [
    PokeType.FIRE
  ],
  "api_moves": [
    "stomp",
    "double-kick",
    "tackle",
    "take-down",
    "double-edge",
    "tail-whip",
    "growl",
    "ember",
    "fire-spin",
    "hypnosis",
    "agility",
    "quick-attack",
    "fire-blast",
    "flame-wheel",
    "bounce",
    "flare-blitz",
    "double-hit",
    "flame-charge",
    "inferno"
  ],
  "moves": [
    "double-kick",
    "tackle",
    "growl",
    "ember",
    "fire-spin",
    "quick-attack",
    "flare-blitz",
    "fire-fang",
    "flamethrower",
    "fire-punch",
    "morning-sun",
    "sunny-day",
    "eruption"
  ],
  "evolution_chain": {
    "id": 32,
    "item": null,
    "species": [
      {
        "name": "ponyta",
        "order": 83,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "rapidash",
        "order": 84,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 77,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 40,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 55,
    "speed": 90,
    "ability_power": 85
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
